import { SliderFill } from "../../../../../ui/slider/fill.js";
import { SliderThumb } from "../../../../../ui/slider/thumb.js";
import { SliderTrack } from "../../../../../ui/slider/track.js";
import { VolumeSliderRoot } from "../../../../../ui/volume-slider/root.js";
import { SliderFill as SliderFill$1, SliderThumb as SliderThumb$1, SliderTrack as SliderTrack$1 } from "./slider.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/shared/components/sliders/volume-slider.tsx
/** @jsxImportSource react */
function VolumeSlider({ className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(VolumeSliderRoot, {
		className: (state) => cn("media-slider", "media-volume-slider", resolveClassName(className, state)),
		thumbAlignment: "edge",
		...props,
		children: [/* @__PURE__ */ jsx(SliderTrack, {
			render: /* @__PURE__ */ jsx(SliderTrack$1, {}),
			children: /* @__PURE__ */ jsx(SliderFill, { render: /* @__PURE__ */ jsx(SliderFill$1, {}) })
		}), /* @__PURE__ */ jsx(SliderThumb, {
			render: /* @__PURE__ */ jsx(SliderThumb$1, {}),
			className: "media-volume-slider-thumb"
		})]
	});
}
//#endregion
export { VolumeSlider };

//# sourceMappingURL=volume-slider.js.map